import { render, staticRenderFns } from "./InventoryModuleLayout.vue?vue&type=template&id=1fca3bd7"
import script from "./InventoryModuleLayout.vue?vue&type=script&lang=js"
export * from "./InventoryModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports